import { useFirestoreUserSWR } from "./use-firestore-user-swr";
import { useUserFirestorePersistence } from "./use-user-firestore-persistence";
import { User } from "./user";

export function useMutateUser(): useMutateUserReturn {
  const { mutate } = useFirestoreUserSWR();
  const { upsertUser } = useUserFirestorePersistence();

  const updateUser = async (updatedUser: User): Promise<void> => {
    await mutate(
      upsertUser(updatedUser).then(() => updatedUser),
      { optimisticData: updatedUser, revalidate: false },
    );
  };

  return { updateUser };
}

export type useMutateUserReturn = {
  updateUser: (user: User) => Promise<void>;
};
